const block = document.querySelector('section.hero-updated');

if(block) {
    let words = block.querySelectorAll('.anim-vertical span');
    let animLength = words.length * 3;
    words.forEach(function(word, index){
        word.style.animation =  'animUp ' + animLength  + 's linear infinite 0s';
        word.style.animationDelay = 3 * index + 's';
    });

    let popup = block.querySelector('.video-popup');
    if(popup) {
        let watchBtn = block.querySelector('.video-btn');
        let overlay = block.querySelector('.video-overlay');
        let closeBtn = block.querySelector('.close-popup');
        let iframe = block.querySelector('iframe');
        let videoSrc = null;
        if(iframe) {
            videoSrc = iframe.getAttribute('src');
        }
    
        watchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if(popup.classList.contains('show-popup')) {
                closePopup();
            }
            else {
                if(iframe.getAttribute('src') == '') {
                    iframe.setAttribute('src', videoSrc);
                }
                popup.classList.add('show-popup');
                overlay.classList.add('show');
                document.querySelector('body').classList.add('no-scroll');
            }
        });
    
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closePopup();
        });

        document.addEventListener('click', event => {
            const isClickInside = overlay.contains(event.target) || popup.querySelector('.popup-top').contains(event.target);
            if (isClickInside && popup.classList.contains('show-popup')) {
              closePopup();
            }
        });
        
        function closePopup() {
            popup.classList.remove('show-popup');
            overlay.classList.remove('show');
            document.querySelector('body').classList.remove('no-scroll');
            popup.querySelector('iframe').setAttribute('src', '');
        }
    }
}